import {AfterViewInit, Directive, Input, OnDestroy, OnInit} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[subcategory]'
})
export class SetPropertySubcategoryLabelDirective implements AfterViewInit, OnDestroy, OnInit {
  @Input() subcategory

  sub;

  constructor(public control: NgControl) {
  }

  ngOnInit() {
    const parent = this.control.control.parent;
    if (parent.get('propertyCategory').value == 2) {
      this.control.control.patchValue(this.subcategory.find(item => item.forId == 2).value);
    }
  }

  setLabel(value) {
    const parent = this.control.control.parent;
    const label = this.subcategory.find(item => item.value === value).label;
    parent.get('propertySubcategoryLabel').patchValue(label);
  }

  ngAfterViewInit() {
    const selectedCode = this.control.control.value;
    if (selectedCode) {
      this.setLabel(selectedCode);
    }
    this.sub = this.control.control.valueChanges.subscribe(value => {
      if (value) {
        this.setLabel(value);
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}
